import React, { useEffect } from 'react';

export default (pathname, excludedPaths = [], WrappedComponent) => props => {
    useEffect(() => { 
        window.localStorage.setItem("lastVisited", pathname); 
        return excludedPaths.includes(pathname) ? () => window.localStorage.setItem("lastVisited", "") : undefined;
    })
    return <WrappedComponent {...props} />
}